export default __webpack_public_path__ + "static/outsource@768-75e10e7ea9e226aa942ab90b8cac6228.png";